import { createSlice } from "@reduxjs/toolkit";
import { fetchUserById, updateUserProfile } from "./thunk";

export const initialState = {
  error: "",
  success: "",
  user: [],
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserById.pending, (state) => {
        state.error = null,
        state.success = ""
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateUserProfile.pending, (state) => {
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.success = "Profile updated successfully";
        state.user = { ...state.user, ...action.payload };
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.error = action.payload;
      })
      
  },
});

export default ProfileSlice.reducer;
